module.exports = __webpack_public_path__ + "static/media/spinner_blue.7b3f784a.svg";